import React from "react";
import { Parallax } from "react-parallax";
import img1 from "../img/para1.jpg";
import Home from "./Home";
const Paral = () => {
  return (
    <div name="Home">
      <Parallax
        blur={1}
        className={"absolute scroll-smooth min-w-screen min-h-screen"}
        bgImage={img1}
        bgImageAlt="parallax efect one"
        strength={600}
      >
        <section
          aria-label="about
          me
          home
          section"
          className="flex items-center min-h-screen py-10 min-w-screen sm:py-0"
        >
          <Home />
        </section>
      </Parallax>
    </div>
  );
};

export default Paral;
